var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCollapsemodeicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3333 10.8333C14.2538 10.8333 15 10.0871 15 9.16667C15 8.24619 14.2538 7.5 13.3333 7.5C12.4129 7.5 11.6667 8.24619 11.6667 9.16667C11.6667 10.0871 12.4129 10.8333 13.3333 10.8333Z",
    stroke: "#767676"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3333 17.4998C14.2538 17.4998 15 16.7536 15 15.8332C15 14.9127 14.2538 14.1665 13.3333 14.1665C12.4129 14.1665 11.6667 14.9127 11.6667 15.8332C11.6667 16.7536 12.4129 17.4998 13.3333 17.4998Z",
    stroke: "#767676"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.16667 2.50016C3.24619 2.50016 2.5 3.24636 2.5 4.16683C2.5 5.0873 3.24619 5.8335 4.16667 5.8335C5.08714 5.8335 5.83333 5.0873 5.83333 4.16683C5.83333 3.24636 5.08714 2.50016 4.16667 2.50016Z",
    stroke: "#767676"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.1665 6.6665V12.4998C4.1665 14.0712 4.1665 14.8568 4.65466 15.345C5.14281 15.8332 5.92849 15.8332 7.49984 15.8332H11.6665",
    stroke: "#767676"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4.1665 5.8335C4.1665 7.40485 4.1665 8.19052 4.65466 8.67866C5.14281 9.16683 5.92849 9.16683 7.49984 9.16683H11.6665",
    stroke: "#767676"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollapsemodeicon);
export default __webpack_public_path__ + "static/media/collapsemodeicon.61be0af6612d14267dc42482160b4561.svg";
export { ForwardRef as ReactComponent };